<template>
  <div class="quote__list-insured">
    <div class="quote__accordion">
      <base-accordion alwaysDisplay>
        <template v-slot:name>
          <span>
            {{ $t('renew.car_info.provide_plate_number.header') }}
          </span>
        </template>
        <template v-slot:content>
          <div class="inputList">
            <base-input
              v-if="showPlateNumber"
                :placeholder="$t('renew.common.plate_number')"
                :validation="$v.plateNumber"
                v-model="plateNumber"
                :error="$v.plateNumber.$dirty && $v.plateNumber.$invalid"
                :mask="'#'.repeat(6)"
                inputMode="numeric"
                @input="onEditPlateNumber"
            >
              <template v-slot:empty-input-error>
                {{ $t('qic.error.provide_plate_number') }}
              </template>
            </base-input>

            <base-select
              v-if="showPlateType"
              style="z-index: 5;"
              :options="plateTypes"
              :caret="true"
              :validation="$v.plateType"
              v-model="plateType"
              :error="$v.plateType.$dirty && $v.plateType.$invalid"
              name="type"
              select-key="code"
              @input="onEditPlateType"
              :select-label="locale === 'ar' ? 'descAr' : 'desc'"
              :placeholder="$t('qic_quote_motor_info_plate_type')">
            </base-select>
          </div>
        </template>
      </base-accordion>
    </div>
  </div>
</template>

<script>
import { BaseAccordion, BaseInput, BaseSelect } from 'qic-components'
import { maxLength, required, numeric } from 'vuelidate/lib/validators'

export default {
  name: 'PlateNumberInfo',
  components: {
    BaseSelect,
    BaseAccordion,
    BaseInput
  },
  props: {
    plateTypes: {},
    showPlateNumber: { type: Boolean, default: true },
    showPlateType: { type: Boolean, default: true }
  },
  emits: [
    'editPlateNumber',
    'editPlateType'
  ],
  data () {
    return {
      plateNumber: null,
      plateType: null,
      locale: this.$i18n.locale
    }
  },
  methods: {
    onEditPlateNumber () {
      this.$emit('editPlateNumber', this.plateNumber)
    },
    onEditPlateType () {
      this.$emit('editPlateType', this.plateType)
    },
    isValid () {
      this.$v.$touch()
      const isPlateNumberValid = this.showPlateNumber ? !this.$v.plateNumber.$invalid : true
      const isPlateTypeValid = this.showPlateType ? !this.$v.plateType.$invalid : true
      return isPlateNumberValid && isPlateTypeValid
    }
  },
  validations () {
    return {
      plateNumber: {
        required,
        maxLength: maxLength(6),
        numeric
      },
      plateType: {
        required
      }
    }
  }
}
</script>
